<template >
    <div class="product-list-element" >
        <img class="cdn-image" :src="cdnImage"/>
        <div class="details-box" >
            <div class="display-series">{{product.salesName}}</div>
            <div class="display-series"  >
                {{product.SKU}}
            </div>
            <div class="sku">{{formatCurrency(priceListPrice)}}</div>
        </div>
        <div class="pricing-box" style="flex-direction: row; align-items: center;" >
            <img  v-if="added" style="width: 44px;height: 44px;align-self:center;cursor: pointer;" @click="removeFocusProduct" src="@/assets/RemoveCart.svg"/>
            <img  v-if="!added && canBeAdded(product)" style="width: 44px;height: 44px;align-self:center;cursor: pointer;" @click="addFocusProduct" src="@/assets/PlusGreen.svg"/>
        </div>

        <div>            
        </div>
        
    </div>
    
</template>

<script>
 
 export default {
     name: "ProductBudgetListElement",
     props: {
         product: {
             avatar: '',
             salesName:'',
             defaultPrice: 0,
             displaySeries:'',
             SKU:'',
             availability: {
                 state: {
                     state: "active",
                     message: "Tilgjengelig",
                     buyable: true
                 },
                 roof: 250,
                 qty: 190
             }
         },
         remainingBudget: {type:Number, default:0},
         budgetActive: {type:Boolean, default:true},
         budgetItemsSelected:{type:Array, default:()=>{return []}},
         budgetPriceList:{type:Array, default:()=>{return []}},
         party:null
         
     },
     emits:['budget-item-picked','budget-item-removed'],
     computed:{
         cdnImage(){
             let avatarFile = ''
             if(this.product.images.productMain != null){
                 if(this.product.images.productMain.length > 0){
                     if(this.product.images.productMain[0].image){
                         avatarFile = this.product.images.productMain[0].image.name
                     }
                 }
             }
             return `${process.env.VUE_APP_CDN_URL}images/pim/202/${avatarFile}`
         },
         seriesIdentifier(){
             return this.product.displaySeries.toUpperCase()
             // return this.product.salesName.substr(0, this.product.salesName.indexOf(' ')).toUpperCase()
         },
         added(){
            return this.budgetItemsSelected.findIndex((el)=>{return el.artno === this.product.SKU}) >= 0;
         },
        priceListPrice(){
          let prod = this.budgetPriceList.findIndex((el)=>{return el.artno == this.product.SKU})
          return prod >= 0 ? this.budgetPriceList[prod].price : 999999;
        },
     },
     methods: {
         scrollToTop() {
             window.scrollTo(0,0);
         },
         removeFocusProduct(){
                this.$emit('budget-item-removed', {artno:this.product.SKU})
         },
         addFocusProduct(){
           let prod = this.budgetPriceList.findIndex((el)=>{return el.artno == this.product.SKU})
          let price  = prod >= 0 ? this.budgetPriceList[prod].price : 999999;

             this.$emit('budget-item-picked', {artno:this.product.SKU, price:price, optionId:this.budgetPriceList[prod].optionId})
         },

         canBeAdded(){
             
             //Pre 23mar22 update: the following 3 lines replace the one below
             // let prod = this.budgetPriceList.findIndex((el)=>{return el.artno == this.product.SKU})
             // let price  = prod >= 0 ? this.budgetPriceList[prod].price : 999999;
             // return price <= this.remainingBudget
             return 0 <= this.remainingBudget
                 && this.budgetActive
                 && this.budgetItemsSelected.findIndex((el)=>{return el.artno === this.product.SKU}) === -1
         },
         formatCurrency(raw){
             return raw.toLocaleString().replace(/,/g," ")
       }

     },


 }
</script>

<style scoped>
.input-wrapper{
    height:60px;
}
</style>
